import {createApp}  from "vue3";
import QuizResult from "./quiz-result";
import QuestionResult from "./quiz-question-result";

export default class Quiz {
    /**
     * Constructor
     * @param $el
     */
    constructor($el) {
        this.$el = $el;

        this.init();
    }

    /**
     * Init
     * @return {{scores: *, questions: (*|*[]), currentQuestion: null, currentAnswer: null}}
     */
    init() {
        const questions = quizData.questions;
        const scores = quizData.scores;

        const app = createApp({
            data() {
                return {
                    currentQuestionIndex: 0,
                    questions: questions,
                    scores: scores,
                    currentAnswer: null,
                    score: 0,
                    showQuizResults: false
                }
            },
            computed: {
                /**
                 * Current question
                 * @return {*}
                 */
                currentQuestion() {
                    return this.questions[this.currentQuestionIndex];
                },
                /**
                 * Is the current question the last question?
                 * @return {boolean}
                 */
                isLastQuestion() {
                    return (this.currentQuestionIndex + 1) === this.questions.length;
                },
                /**
                 * Get current correct answer
                 */
                currentCorrectAnswer() {
                    return this.currentQuestion.answers.find(answer => answer.isCorrect);
                }
            },
            methods: {
                /**
                 * Select answer
                 * @param answer
                 */
                selectAnswer(answer) {
                    this.currentAnswer = answer;
                    this.score += answer.points;
                },
                /**
                 * Go to the next question
                 */
                nextQuestion() {
                    if (! this.isLastQuestion) {
                        this.currentAnswer = null;
                        this.currentQuestionIndex++;
                    } else {
                        this.showQuizResults = true;
                    }
                }
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];
        app.component('question-result', QuestionResult);
        app.component('quiz-result', QuizResult);

        // mount the app
        app.mount(this.$el);
    }
}